import { Store, StoreConfig } from '@datorama/akita';
import { Properties } from '../api';

export interface GuestReportState {
  report?: Properties.GuestReportModel;
  maintenanceTicketNumber?: number;
}

@StoreConfig({ name: 'guest-report', resettable: true })
export class GuestReportStore extends Store<GuestReportState> {
  constructor() {
    super({});
  }
}

export const guestReportStore = new GuestReportStore();
